import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_regular, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  width: 100%;
  flex: 1;
  border: none;
  background-color: transparent;
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextPrimary};
  ${font_md};
  resize: none;
  min-height: 80px;

  &:disabled {
    cursor: not-allowed;
  }

  &.medium {
    padding: ${spacing(4)} 0;
  }

  &.small {
    padding: ${spacing(2)} 0;
  }

  &::placeholder {
    color: ${text_colorTextSecondary};
    text-overflow: ellipsis;
    overflow: hidden;
  }
`
